import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

const TokenIdKey = 'tokenId'

const ExpiresInKey = 'Admin-Expires-In'

export function getToken() {
  localStorage.getItem(TokenIdKey)
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  localStorage.setItem(TokenIdKey, token)
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  localStorage.removeItem(TokenIdKey)
  return Cookies.remove(TokenKey)
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}





export function getTokenId() {
  return localStorage.getItem(TokenIdKey)
}

export function setTokenId(tokenId) {
  return localStorage.setItem(TokenIdKey, tokenId)
}

export function removeTokenId() {
  return localStorage.removeItem(TokenIdKey)
}



// WEBPACK FOOTER //
// ./src/utilsCloud/auth.js